// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--2-7Pu","button":"dece2e673c--button--2J2bs","three_point":"dece2e673c--three_point--CmXX_","added_info":"dece2e673c--added_info--20-Mg"};